"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const pattern_1 = require("./pattern");
const pattern = __importStar(require("./pattern"));
class InvalidScopeError extends Error {
}
exports.InvalidScopeError = InvalidScopeError;
// Parse a scope string into a Pattern array
function parse(scope) {
    return scope.split(":").map(pattern => pattern.split(".").map(segment => {
        switch (segment) {
            case "**":
                return pattern_1.AnyMultiple;
            case "*":
                return pattern_1.AnySingle;
            default:
                return segment;
        }
    }));
}
// Stringify a Pattern array
function stringify(scope) {
    return scope
        .map(pattern => pattern
        .map(segment => {
        switch (segment) {
            case pattern_1.AnyMultiple:
                return "**";
            case pattern_1.AnySingle:
                return "*";
            default:
                return segment;
        }
    })
        .join("."))
        .join(":");
}
function intersect(left, rightA, rightB) {
    // INVARIENT: rightA.length === rightB.length
    // INVARIENT: rightA.length > 0
    // INVARIENT: rightB.length > 0
    const [a, ...restA] = rightA;
    const [b, ...restB] = rightB;
    if (!restA.length) {
        return pattern.getIntersection(a, b).map(pattern => [...left, pattern]);
    }
    return pattern
        .getIntersection(a, b)
        .map(pattern => intersect([...left, pattern], restA, restB))
        .reduce((x, y) => x.concat(y), []);
}
function validate(scope) {
    const patterns = scope.split(":");
    return (patterns.length === 3 &&
        patterns.every(pattern => /^(([a-zA-Z0-9_-]+|(\*(?!\*\*))+)\.)*([a-zA-Z0-9_-]+|(\*(?!\*\*))+)$/.test(pattern)));
}
exports.validate = validate;
function normalize(scope) {
    if (!validate(scope)) {
        throw new InvalidScopeError("The scope is invalid.");
    }
    return scope
        .split(":")
        .map(domain => domain
        .split(".")
        .map((part, i, parts) => {
        if (part !== "**" || (parts[i + 1] !== "**" && parts[i + 1] !== "*"))
            return part;
        parts[i + 1] = "**";
        return "*";
    })
        .join("."))
        .join(":");
}
exports.normalize = normalize;
function s(winners, candidate) {
    if (isSuperset(winners, candidate))
        return winners;
    return winners.concat(normalize(candidate));
}
// returns a de-duplicated array of scope rules
function simplify(collection) {
    return collection
        .reduce(s, [])
        .reduceRight(s, [])
        .sort();
}
exports.simplify = simplify;
function getIntersection(scopeOrCollectionA, scopeOrCollectionB) {
    const collectionA = typeof scopeOrCollectionA === "string"
        ? [scopeOrCollectionA]
        : scopeOrCollectionA;
    const collectionB = typeof scopeOrCollectionB === "string"
        ? [scopeOrCollectionB]
        : scopeOrCollectionB;
    if (!collectionA.every(validate)) {
        throw new InvalidScopeError("One or more of the scopes in `collectionA` is invalid.");
    }
    if (!collectionB.every(validate)) {
        throw new InvalidScopeError("One or more of the scopes in `collectionB` is invalid.");
    }
    const patternsA = collectionA.map(parse).filter(p => p.length > 0);
    const patternsB = collectionB.map(parse).filter(p => p.length > 0);
    return simplify(patternsA
        .map(a => patternsB
        .map(b => intersect([], a, b))
        .reduce((x, y) => x.concat(y), []))
        .reduce((x, y) => x.concat(y), [])
        .map(stringify));
}
exports.getIntersection = getIntersection;
function hasIntersection(scopeOrCollectionA, scopeOrCollectionB) {
    return getIntersection(scopeOrCollectionA, scopeOrCollectionB).length > 0;
}
exports.hasIntersection = hasIntersection;
function isEqual(scopeOrCollectionA, scopeOrCollectionB) {
    const collectionA = simplify(typeof scopeOrCollectionA === "string"
        ? [scopeOrCollectionA]
        : scopeOrCollectionA);
    const collectionB = simplify(typeof scopeOrCollectionB === "string"
        ? [scopeOrCollectionB]
        : scopeOrCollectionB);
    return (collectionA.length === collectionB.length &&
        collectionA.every((a, i) => a === collectionB[i]));
}
exports.isEqual = isEqual;
function isSuperset(scopeOrCollectionA, scopeOrCollectionB) {
    if (Array.isArray(scopeOrCollectionA)) {
        return simplify(scopeOrCollectionA).some(a => isSuperset(a, scopeOrCollectionB));
    }
    if (!validate(scopeOrCollectionA)) {
        throw new InvalidScopeError("A scope in `scopeOrCollectionA` is invalid.");
    }
    if (Array.isArray(scopeOrCollectionB)) {
        return simplify(scopeOrCollectionB).every(b => isSuperset(scopeOrCollectionA, b));
    }
    if (!validate(scopeOrCollectionB)) {
        throw new InvalidScopeError("A scope in `scopeOrCollectionB` is invalid.");
    }
    const a = parse(scopeOrCollectionA);
    const b = parse(scopeOrCollectionB);
    return (a.length === b.length &&
        a.every((patternA, i) => pattern.isSuperset(patternA, b[i])));
}
exports.isSuperset = isSuperset;
function isStrictSuperset(scopeOrCollectionA, scopeOrCollectionB) {
    return (!isEqual(scopeOrCollectionA, scopeOrCollectionB) &&
        isSuperset(scopeOrCollectionA, scopeOrCollectionB));
}
exports.isStrictSuperset = isStrictSuperset;
function isSubset(scopeOrCollectionA, scopeOrCollectionB) {
    return isSubset(scopeOrCollectionB, scopeOrCollectionA);
}
exports.isSubset = isSubset;
function isStrictSubset(scopeOrCollectionA, scopeOrCollectionB) {
    return (!isEqual(scopeOrCollectionA, scopeOrCollectionB) &&
        isSubset(scopeOrCollectionA, scopeOrCollectionB));
}
exports.isStrictSubset = isStrictSubset;
/**
 * @deprecated Since version 2.1. Will be deleted in version 3.0. Replace
 * "strict" calls with {@link isSuperset}, and weak mode with
 * {@link hasIntersection}.
 */
function test(rule, subject, strict = true) {
    return strict ? isSuperset(rule, subject) : hasIntersection(rule, subject);
}
exports.test = test;
/**
 * @deprecated Since version 2.1. Will be deleted in version 3.0. Replace
 * "strict" calls with {@link isSuperset}, and weak mode with
 * {@link hasIntersection}.
 */
exports.can = test;
/**
 * @deprecated Since version 2.1. Will be deleted in version 3.0. Renamed to
 * {@link getIntersection}.
 */
exports.limit = getIntersection;
